import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Box } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Outlet, useLocation } from "react-router";
import "./App.css";
import "./theme/designSystem.css";
import { buildAppTheme } from "./theme/appTheme";
import StaticBackground from "@/components/Background";
import ProcessNotificationBridge from "@/components/ProcessNotificationBridge/ProcessNotificationBridge";
import { PwaUpdatePrompt } from "@/components/PwaUpdatePrompt/PwaUpdatePrompt";
import { AppDialogProvider } from "./context/AppDialogContext";
import { NotificationProvider } from "./context/NotificationContext";

/** Hide the static bootstrap loading overlay once the app has mounted (root loader completed). */
function hideBootstrapLoading() {
  const el = document.getElementById("bootstrap-loading");
  if (el) {
    el.style.opacity = "0";
    el.style.pointerEvents = "none";
    const remove = () => {
      el.remove();
    };
    el.addEventListener("transitionend", remove, { once: true });
    // Fallback if transitionend does not fire (e.g. reduced motion)
    setTimeout(remove, 250);
  }
}

const App = observer(() => {
  const location = useLocation();
  const isPromptsBuilderRoute = location.pathname === "/prompts";
  const theme = buildAppTheme();

  useEffect(() => {
    hideBootstrapLoading();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NotificationProvider>
        <AppDialogProvider>
          <ProcessNotificationBridge />
          <PwaUpdatePrompt />
          <div className="animated-background">
            <StaticBackground isEmbedded={false} />
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              position: "relative",
              zIndex: 1,
              ...(isPromptsBuilderRoute
                ? {
                    flex: 1,
                    minHeight: "100dvh",
                    bgcolor: "transparent",
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  }
                : {}),
            }}
          >
            <Outlet />
          </Box>
        </AppDialogProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
});

export default App;
